<app-header title="Datenschutzerklärung" i18n-title/>

<main>
  <div class="m-5 p-1">
    <p class="fw-bold" i18n>Datenschutz</p>
    <p i18n>
      Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst.
      Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften
      sowie dieser Datenschutzerklärung.
    </p>
    <p i18n>
      Die Nutzung unserer Webseite ist in der Regel ohne Angabe personenbezogener Daten möglich.
      Soweit auf unseren Seiten personenbezogene Daten (beispielsweise Name, Anschrift oder E-Mail-Adressen) erhoben
      werden, erfolgt dies, soweit möglich, stets auf freiwilliger Basis.
      Diese Daten werden ohne Ihre ausdrückliche Zustimmung nicht an Dritte weitergegeben.
    </p>
    <p i18n>
      Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail)
      Sicherheitslücken aufweisen kann.
      Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.
    </p>

    <p class="fw-bold" i18n>Erfassung allgemeiner Informationen</p>
    <p i18n>
      Wenn Sie auf unsere Webseite zugreifen, werden automatisch Informationen allgemeiner Natur erfasst.
      Diese Informationen (Server-Logfiles) beinhalten etwa die Art des Webbrowsers, das verwendete Betriebssystem, den
      Domainnamen Ihres Internet Service Providers und Ähnliches.
      Hierbei handelt es sich ausschließlich um Informationen, welche keine Rückschlüsse auf Ihre Person zulassen.
      Diese Informationen sind technisch notwendig, um von Ihnen angeforderte Inhalte von Webseiten korrekt auszuliefern
      und fallen bei Nutzung des Internets zwingend an.
      Anonyme Informationen dieser Art werden von uns statistisch ausgewertet, um unseren Internetauftritt und die
      dahinterstehende Technik zu optimieren.
    </p>

    <p class="fw-bold" i18n>TLS-Verschlüsselung</p>
    <p i18n>
      Um die Sicherheit Ihrer Daten bei der Übertragung zu schützen, verwenden wir dem aktuellen Stand der Technik
      entsprechende Verschlüsselungsverfahren (z.B. TLS) über HTTPS.
    </p>

    <p class="fw-bold" i18n>Kontaktformular</p>
    <p i18n>
      Treten Sie per E-Mail oder Kontaktformular mit uns in Kontakt, werden die von Ihnen gemachten Angaben zum Zwecke
      der Bearbeitung der Anfrage sowie für mögliche Anschlussfragen gespeichert.
    </p>

    <p class="fw-bold" i18n>Cookies</p>
    <p i18n>
      Wie viele andere Webseiten verwenden wir auch sogenannte "Cookies". Cookies sind kleine Textdateien, die von einem
      Webseitenserver auf Ihre Festplatte übertragen werden.
      Hierdurch erhalten wir automatisch bestimmte Daten wie z.B. IP-Adresse, verwendeter Browser, Betriebssystem über
      Ihren Computer und Ihre Verbindung zum Internet.
    </p>
    <p i18n>
      Cookies können nicht verwendet werden, um Programme zu starten oder Viren auf einen Computer zu übertragen.
      Anhand der in Cookies enthaltenen Informationen können wir Ihnen die Navigation erleichtern und die korrekte
      Anzeige unserer Webseiten ermöglichen.
    </p>
    <p i18n>
      In keinem Fall werden die von uns erfassten Daten an Dritte weitergegeben oder ohne Ihre Einwilligung eine
      Verknüpfung mit personenbezogenen Daten hergestellt.
    </p>
    <p i18n>
      Natürlich können Sie unsere Website grundsätzlich auch ohne Cookies betrachten. Internet-Browser sind regelmäßig
      so eingestellt, dass sie Cookies akzeptieren.
      Sie können die Verwendung von Cookies jederzeit über die Einstellungen Ihres Browsers deaktivieren.
      Bitte verwenden Sie die Hilfefunktionen Ihres Internetbrowsers, um zu erfahren, wie Sie diese Einstellungen ändern
      können.
      Bitte beachten Sie, dass einzelne Funktionen unserer Website möglicherweise nicht funktionieren, wenn Sie die
      Verwendung von Cookies deaktiviert haben.
    </p>

    <p class="fw-bold" i18n>Verwendung von HealthKit</p>
    <p i18n>
      HealthKit-Daten sind aktuell kein Bestandteil aggregierter Daten und werden weder für Werbe- und
      Vermarktungszwecke verwendet noch mit Dritten geteilt.
      Alle HealthKit Daten werden in voller Übereinstimmung mit den Apple HealthKit Richtlinien verarbeitet.
    </p>

    @if (isUsingAppleMaps) {
      <p class="fw-bold" i18n>Verwendung von Apple Maps</p>
      <p i18n>
        Diese Webseite verwendet Apple Maps APIs, um geografische Informationen visuell darzustellen.
        Bei der Nutzung von Apple Maps werden von Apple auch Daten über die Nutzung der Kartenfunktionen durch Besucher
        erhoben, verarbeitet und genutzt.
        Nähere Informationen über die Datenverarbeitung durch Apple können Sie den
        <a href="https://www.apple.com/legal/privacy/data/de/apple-maps" i18n-href target="_blank">
          Apple Maps Datenschutzhinweisen
        </a> entnehmen.
      </p>
    } @else {
      <p class="fw-bold" i18n>Verwendung von Google Maps</p>
      <p i18n>
        Diese Webseite verwendet Google Maps APIs, um geografische Informationen visuell darzustellen.
        Bei der Nutzung von Google Maps werden von Google auch Daten über die Nutzung der Kartenfunktionen durch
        Besucher erhoben, verarbeitet und genutzt.
        Nähere Informationen über die Datenverarbeitung durch Google können Sie den
        <a href="https://policies.google.com/privacy" target="_blank">Google-Datenschutzhinweisen</a> entnehmen.
        Dort können Sie im Datenschutzcenter auch Ihre persönlichen Datenschutz-Einstellungen verändern.
      </p>
      <p i18n>
        Ausführliche Anleitungen zur Verwaltung der eigenen Daten im Zusammenhang mit Google-Produkten
        <a href="https://www.dataliberation.org/" target="_blank">finden Sie hier</a>.
      </p>
    }

    <p class="fw-bold" i18n>Ihre Rechte auf Auskunft, Berichtigung, Sperre, Löschung und Widerspruch</p>
    <p i18n>
      Sie haben das Recht, jederzeit Auskunft über Ihre bei uns gespeicherten personenbezogenen Daten zu erhalten.
      Ebenso haben Sie das Recht auf Berichtigung, Sperrung oder, abgesehen von der vorgeschriebenen Datenspeicherung
      zur Geschäftsabwicklung, Löschung Ihrer personenbezogenen Daten.
      Bitte wenden Sie sich dazu an unseren Datenschutzbeauftragten. Die Kontaktdaten finden Sie ganz unten.
    </p>
    <p i18n>
      Damit eine Sperre von Daten jederzeit berücksichtigt werden kann, müssen diese Daten zu Kontrollzwecken in einer
      Sperrdatei vorgehalten werden.
      Sie können auch die Löschung der Daten verlangen, soweit keine gesetzliche Archivierungsverpflichtung besteht.
      Soweit eine solche Verpflichtung besteht, sperren wir Ihre Daten auf Wunsch.
    </p>
    <p i18n>
      Sie können Änderungen oder den Widerruf einer Einwilligung durch entsprechende Mitteilung an uns mit Wirkung für
      die Zukunft vornehmen.
    </p>

    <p class="fw-bold" i18n>Änderung unserer Datenschutzbestimmungen</p>
    <p i18n>
      Wir behalten uns vor, diese Datenschutzerklärung gelegentlich anzupassen, damit sie stets den aktuellen
      rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen in der
      Datenschutzerklärung umzusetzen, z.B. bei der Einführung neuer Services. Für Ihren erneuten Besuch gilt dann die
      neue Datenschutzerklärung.
    </p>

    <p class="fw-bold" i18n>Fragen zum Datenschutz</p>
    <p i18n>
      Wenn Sie Fragen zum Datenschutz haben, schreiben Sie uns bitte eine E-Mail oder nutzen Sie unser
      <a [routerLink]="['/contact']">Kontaktformular</a>.
    </p>

    <p class="mt-5" style="color: #868686;" i18n>
      Die Datenschutzerklärung wurde mit dem
      <a href="https://www.activemind.de/datenschutz/generatoren/datenschutzerklaerung/" target="_blank">
        Datenschutzerklärungs-Generator der activeMind AG
      </a>
      erstellt.
    </p>
  </div>

  <app-large-logo-shear/>
</main>
